import type { CardIid } from '@sw/engine';
import type { StageTarget } from '../game/stages';
import { create } from 'zustand';

export interface Toast {
  id: number;
  kind: 'info' | 'success' | 'warn' | 'error';
  text: string;
}

interface UiState {
  toasts: Toast[];
  /** Hay una animación de transición de era en pantalla. */
  transitionActive: boolean;
  setTransitionActive(b: boolean): void;
  /** Carta abierta en la ficha de detalle: `ownerSeat` null = de mi mano. */
  inspect: { iid: CardIid; ownerSeat: number | null } | null;
  inspectCard(iid: CardIid, ownerSeat: number | null): void;
  closeInspect(): void;
  /** Etapa de maravilla abierta en su ficha. */
  stageInspect: StageTarget | null;
  inspectStage(t: StageTarget): void;
  closeStageInspect(): void;
  /** Asiento → contador: hace destellar su ficha en la barra (acaba de construir una etapa). */
  stageFlash: Record<number, number>;
  flashStage(seats: number[]): void;
  toast(kind: Toast['kind'], text: string, ms?: number): void;
  dismiss(id: number): void;
}

let nextId = 1;

export const useUi = create<UiState>((set, get) => ({
  toasts: [],
  transitionActive: false,
  setTransitionActive(transitionActive) {
    set({ transitionActive });
  },
  inspect: null,
  inspectCard(iid, ownerSeat) {
    set({ inspect: { iid, ownerSeat } });
  },
  closeInspect() {
    set({ inspect: null });
  },
  stageInspect: null,
  inspectStage(stageInspect) {
    set({ stageInspect });
  },
  closeStageInspect() {
    set({ stageInspect: null });
  },
  stageFlash: {},
  flashStage(seats) {
    set((s) => {
      const next = { ...s.stageFlash };
      for (const seat of seats) next[seat] = (next[seat] ?? 0) + 1;
      return { stageFlash: next };
    });
  },
  toast(kind, text, ms = 4500) {
    const id = nextId++;
    set((s) => ({ toasts: [...s.toasts.slice(-3), { id, kind, text }] }));
    window.setTimeout(() => get().dismiss(id), ms);
  },
  dismiss(id) {
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
  },
}));
